// @mui material components
import PropTypes from 'prop-types';
import Icon from '@mui/material/Icon';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';
import { useMaterialUIController } from 'context';

function DataTableHeadCell({ width, children, sorted, align, ...rest }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <TableCell
            width={width}
            align={align}
            sx={({ palette, borders, typography }) => ({
                borderBottom: `${borders.borderWidth[1]} solid ${palette.light.main}`,
                fontSize: typography.size.xxs,
                fontWeight: typography.fontWeightBold,
                textTransform: 'uppercase',
                color: darkMode ? 'white.main' : 'text.secondary',
                opacity: 0.7,
                position: 'relative',
                cursor: sorted ? 'pointer' : 'default',
                userSelect: sorted ? 'none' : 'auto',
                px: 3,
                py: 1.5,
            })}
            {...rest}
        >
            <Box component="span">{children}</Box>
            {sorted && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: align !== 'right' ? '16px' : 0,
                        left: align === 'right' ? '-5px' : 'unset',
                        fontSize: '1.25rem',
                    }}
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: -6,
                            color: sorted === 'asc' ? 'text.primary' : 'text.secondary',
                            opacity: sorted === 'asc' ? 1 : 0.5,
                        }}
                    >
                        <Icon>arrow_drop_up</Icon>
                    </Box>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            color: sorted === 'desc' ? 'text.primary' : 'text.secondary',
                            opacity: sorted === 'desc' ? 1 : 0.5,
                        }}
                    >
                        <Icon>arrow_drop_down</Icon>
                    </Box>
                </Box>
            )}
        </TableCell>
    );
}

DataTableHeadCell.defaultProps = {
    width: 'auto',
    sorted: 'none',
    align: 'left',
};

DataTableHeadCell.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.node.isRequired,
    sorted: PropTypes.oneOf([false, 'none', 'asc', 'desc']),
    align: PropTypes.oneOf(['left', 'right', 'center']),
};

export default DataTableHeadCell;
